export enum ENVIRONMENTS {
  PROD = `https://AmendedReturnSAA.azure.chevron.com`,
  DEV = `https://AmendedReturnSAA-dev.azure.chevron.com`,
}
